import {observer} from "mobx-react";
import {useNavigate} from "react-router";
import {convertPlacementProcessOrigin, convertPlacementProcessStatus} from "../../../api";
import {slsPlacementCartStore} from "../../../store";
import {PlacementProcessListItemDto} from "../../../api/sls";
import {useState} from "react";
import {Linq} from "../../ui";

interface SlsProcessListRowProps {
    val: PlacementProcessListItemDto
}

const SlsProcessListRow = observer(function SlsProcessListRow({
                                                                  val
                                                              }: SlsProcessListRowProps) {
    const navigate = useNavigate()
    const link = `/sls/${val.id}`
    const [loading, setLoading] = useState(false)
    const [notClosable, setNotClosable] = useState(false)

    const exists = slsPlacementCartStore.exists(val.id)

    return <tr style={{cursor: 'pointer'}} onClick={() => {
        navigate(link)
    }}>
        <td><Linq to={`${link}`}>{val.correlationId}</Linq></td>
        <td><Linq to={`${link}`}>{convertPlacementProcessOrigin(val.origin)}</Linq></td>
        <td><Linq to={`${link}`}>{val.user}</Linq></td>
        <td><Linq to={`${link}`}>{val.customer}</Linq></td>
        <td><Linq to={`${link}`}>{convertPlacementProcessStatus(val.status)}</Linq></td>
        <td style={{padding: 0, verticalAlign: 'middle', textAlign: 'center'}}>
            {exists && <span
                className={'tag is-rounded is-hoverable is-info is-light'}>{slsPlacementCartStore.indexOf(val) + 1}</span>}
        </td>
        <td>
            {exists && <>
                <button
                    style={{
                        padding: '0.2em 0.7em'
                    }}
                    title={"Aus Stapeleinlagerung entfernen"}
                    className={`button is-small is-rounded is-danger is-inverted`}
                    onClick={async (e) => {
                        e.stopPropagation()
                        slsPlacementCartStore.remove(val)
                    }}
                ><span
                    style={{
                        zoom: '0.8'
                    }}
                    className="material-symbols-outlined"
                >{'remove_shopping_cart'}</span></button>
            </>}
            {!exists && <>
                <button
                    style={{
                        padding: '0.2em 0.7em'
                    }}
                    title={"Zur Stapeleinlagerung hinzufügen"}
                    className={`button is-small is-rounded ${notClosable ? 'is-danger' : 'is-info'} ${loading ? 'is-loading' : ''}`}
                    disabled={notClosable || !slsPlacementCartStore.addIsPossible(val)}
                    onClick={async (e) => {
                        e.stopPropagation()
                        setLoading(true)
                        const success = await slsPlacementCartStore.push({
                            id: val.id,
                            customerId: val.customerId,
                            correlationId: val.correlationId
                        })
                        setNotClosable(!success)
                        setLoading(false)
                    }}
                ><span
                    style={{
                        zoom: '0.8'
                    }}
                    className="material-symbols-outlined"
                >{notClosable ? 'heart_broken' : 'add_shopping_cart'}</span></button>
            </>}
        </td>
    </tr>
})

export {
    SlsProcessListRow
}
